/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Datatable} from '../../../components/Datatable/Datatable'
import {Button} from '../../../components/Button/Button'
import {useNavigate, useLocation} from 'react-router-dom'
import api, {GET, GET_ADM, POST_ADM} from '../../../services/api'
import {toDate} from '../../../utils/formater'
import {Loading} from '../../../components/Loading/Loading'
import SVG from 'react-inlinesvg'
import Swal from 'sweetalert2'
import {DecodedTokenData} from '../../../context/authContext'
import {parseJwt} from '../../../utils/utils'
import {i18n} from '../../../translate/i18n'
import useAuth from '../../../hooks/useAuth'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {
  AggregatorIcon,
  FashionIcon,
  FoodIcon,
  HospitalityIcon,
  VarejoIcon,
} from '../../../components/Icons/IconesPluginSpace'
import {Input} from '../../../components/Input/Input'
import {useSearchParams} from 'react-router-dom'
import {useLocalStorage} from '../../../context/localstorageContext'

type dataType = {
  id: number
  name: string
  type: string
  subdomain: string
  status: string
  active: boolean
  created: Date
  cnpj: String
}

type typeType = {
  type: string
  icon: string
  quantity: number
}

const PluginspaceContent: FC = () => {
  const navigate = useNavigate()
  const _location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const statusOptions = [
    {
      value: 1,
      select: 'Ativo',
    },
    {
      value: 0,
      select: 'Inativo',
    },
    {
      value: 2,
      select: 'Ambos',
    },
  ]
  const [filterStatus, setFilterStatus] = useState<any>(() => {
    const savedItem = localStorage.getItem(_location.pathname)
    const pluginSpaceRecuperado = savedItem ? JSON.parse(savedItem) : null
    const statusFromLocalStorage = pluginSpaceRecuperado ? pluginSpaceRecuperado.status : null
    const res = statusFromLocalStorage || searchParams.get('status')
    const status = statusOptions.find((option) => option.select === res)
    return status ? {label: status.select, value: status.value} : {label: 'Ativo', value: 1}
  })
  const [data, setData] = useState<dataType[]>([])
  const [dataAll, setDataAll] = useState<dataType[]>([])
  const [types, setTypes] = useState<typeType[]>([])
  const [loading, setLoading] = useState(false)
  const [loadingTable, setLoadingTable] = useState(false)
  const [optionsFilter, setOptionsFilter] = useState<any>([])
  const [filterPluginspace, setFilterPluginspace] = useState<any>(() => {
    const savedItem = localStorage.getItem(_location.pathname)
    const pluginSpaceRecuperado = savedItem ? JSON.parse(savedItem) : null
    const typeFromLocalStorage = pluginSpaceRecuperado ? pluginSpaceRecuperado.type : null
    const res = typeFromLocalStorage || searchParams.get('type')
    return res ? {label: res} : {label: 'Todas', value: 0}
  })
  const {deleteItem} = useLocalStorage()

  const {verifyPluginSpace, loginInfo} = useAuth()

  const getUniqueTypes = async (data: any) => {
    const uniqueTypes: any = []
    let index = 1

    data.forEach((item: any) => {
      if (
        item.type &&
        !uniqueTypes.some((obj: any) => obj.select.toLowerCase() === item.type.toLowerCase()) &&
        item.type !== 'group'
      ) {
        const selectCapitalize = capitalize(item.type)
        uniqueTypes.push({select: selectCapitalize, value: index++})
      }
    })

    const newUniqueTypes = [{select: 'Todas', value: 0}, ...uniqueTypes]

    setOptionsFilter(newUniqueTypes)
    return
  }

  function capitalize(str: any) {
    if (!str) return str
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }

  const getData = async () => {
    setLoading(true)
    setLoadingTable(true)

    try {
      //verifica se no token de adm, a plugin space é 2 (Ninegrid)
      const pluginSpaceis2 = verifyPluginSpace()

      if (pluginSpaceis2) {
        const res = await GET_ADM(`/pluginspace`)
        const _data = res.data.map((item: dataType) => {
          return {
            id: item.id,
            name: item.name,
            subdomain: item.subdomain,
            type: item.type,
            status: item.status ? 'ativo' : 'inativo',
            created: toDate(item.created.toString()),
            cnpj: item.cnpj ? item.cnpj : '',
          }
        })
        const activeData = _data.filter((item: any) => {
          const status = filterStatus.label.toLowerCase()
          const type = filterPluginspace.label.toLowerCase()
          if (status === 'ambos' && (type === 'todas' || type === item.type.toLowerCase()))
            return true

          if (status === 'ambos') return item.type.toLowerCase() === type || type === 'todas'

          return item.status === status && (type === 'todas' || item.type.toLowerCase() === type)
        })
        setData(activeData)
        setDataAll(_data)
        setTypesByData(_data)

        await getUniqueTypes(_data)
      } else {
        const res = await POST_ADM(`/pluginspace/beyondchildren`)

        const _data = res.data.map((item: any) => {
          return {
            id: item.id,
            name: item.name,
            subdomain: item.subdomain,
            type: item.type,
            status: item.status ? 'ativo' : 'inativo',
            created: toDate(item.created.toString()),
            cnpj: item.cnpj ? item.cnpj : '',
          }
        })
        const activeData = _data.filter((item: any) => {
          const status = filterStatus.label.toLowerCase()
          const type = filterPluginspace.label.toLowerCase()
          if (status === 'ambos' && (type === 'todas' || type === item.type.toLowerCase()))
            return true

          if (status === 'ambos') return item.type.toLowerCase() === type || type === 'todas'

          return item.status === status && (type === 'todas' || item.type.toLowerCase() === type)
        })
        setData(activeData)
        setDataAll(_data)
        setTypesByData(_data)
      }

      setLoading(false)
      setLoadingTable(false)
    } catch (e) {
      setData([])
      setLoading(false)
      setLoadingTable(false)
      console.log(e)
    }
  }

  function setTypesByData(pluginspaces: dataType[]) {
    try {
      const newData: {
        type: string
        icon: any
        quantity: number
      }[] = []
      pluginspaces.map((p) => {
        const findIndex = newData.findIndex((n) => n.type === p.type)

        if (findIndex !== -1) {
          newData[findIndex].quantity++
        } else {
          newData.push({
            type: p.type,
            icon: getIconType(p.type),
            quantity: 1,
          })
        }
      })

      setTypes(newData.filter((item: typeType) => validType(item.type)))
    } catch (error) {
      console.log(error)
    }
  }

  const validType = (type: string) => {
    if (
      type === 'hospitality' ||
      type === 'food' ||
      type === 'healthcare' ||
      type === 'varejo' ||
      type === 'fashion'
    ) {
      return true
    }
    return false
  }

  function getIconType(type: string) {
    try {
      switch (type) {
        case 'food':
          return <FoodIcon />
          break

        case 'fashion':
          return <FashionIcon />
          break

        case 'varejo':
          return <VarejoIcon />
          break

        case 'hospitality':
          return <FashionIcon />
          break

        case 'aggregator':
          return <AggregatorIcon />
          break

        case 'health':
          return <HospitalityIcon />
          break
        default:
          return <FashionIcon />
      }
    } catch (error) {
      console.log(error)
    }
  }

  const accessPluginspace = async (pluginspaceId: number) => {
    try {
      setLoading(true)
      const res = await GET_ADM(`/token/login-adm/${pluginspaceId}`)
      if (process.env.REACT_APP_JWT_SALT && res && res.accessToken) {
        localStorage.setItem('loginInfo_ninegrid_access', JSON.stringify(res))
        const tkNoSalt = res.accessToken.split(process.env.REACT_APP_JWT_SALT).join('')
        const tk: DecodedTokenData | null = parseJwt(tkNoSalt)
        if (tk) {
          setLoading(false)

          //usado para remover os itens salvos no localStorage.
          deleteItem('pluginSpace')
          deleteItem('pluginConfig')
          deleteItem('locations')
          deleteItem('manual')
          deleteItem('integrations')
          deleteItem('i18nConfig')
          deleteItem('i18nextLng')

          window.location.reload()
          navigate('/dashboard')
        } else {
          setLoading(false)
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Falha ao acessar a Pluginspace!',
          })
        }
      } else {
        setLoading(false)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Falha ao acessar a Pluginspace!',
        })
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Falha ao acessar a Pluginspace!',
      })
    }
  }

  const filterProdutos = async () => {
    try {
      setLoading(true)
      setLoadingTable(true)

      const newFilterType =
        filterPluginspace.label === 'Todas'
          ? dataAll
          : dataAll.filter((data: any) => data.type === filterPluginspace.label.toLowerCase())

      switch (filterStatus.value) {
        case 1:
          const newDataAtivo = newFilterType.filter((item: any) => item.status === 'ativo')
          setData(newDataAtivo)
          setTypesByData(newDataAtivo)
          break
        case 2:
          setData(newFilterType)
          setTypesByData(newFilterType)
          break
        case 0:
          const newDataInativo = newFilterType.filter((item: any) => item.status === 'inativo')
          setData(newDataInativo)
          setTypesByData(newDataInativo)

          break
        default:
          setData(dataAll)
          setTypesByData(dataAll)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
      setLoadingTable(false)
    }
  }

  const modifyUrlParams = async () => {
    const newSearchParams = new URLSearchParams(searchParams)
    const newSaveUrl: {[key: string]: any} = {}

    if (filterStatus.label === 'Ativo') {
      //Deletar pq é Padrão
      newSearchParams.delete('status')
      newSaveUrl.status = undefined
    } else {
      // Adicionar
      newSearchParams.set('status', filterStatus.label)
      newSaveUrl.status = filterStatus.label
    }

    if (filterPluginspace.label === 'Todas') {
      //Deletar pq é Padrão
      newSearchParams.delete('type')
      newSaveUrl.type = undefined
    } else {
      // Adicionar
      newSearchParams.set('type', filterPluginspace.label)
      newSaveUrl.type = filterPluginspace.label
    }

    if (!newSaveUrl.status && !newSaveUrl.type) {
      // Remove pq todos são Padrões
      localStorage.removeItem(_location.pathname)
    } else {
      localStorage.setItem(_location.pathname, JSON.stringify(newSaveUrl))
    }

    setSearchParams(newSearchParams)
  }

  useEffect(() => {
    modifyUrlParams()
  }, [filterStatus, filterPluginspace])

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>Contas</span>
                <BreadCrumbs />
              </h3>
              <div className='card-toolbar'>
                {types.map((item, index) => (
                  <div
                    key={`type-${index}`}
                    style={{
                      padding: 6,
                      margin: 3,
                      textAlign: 'center',
                      width: 120,
                      height: 90,
                      border: '1px solid #eff2f5',
                      borderRadius: 5,
                      flexDirection: 'row',
                    }}
                  >
                    <div style={{textAlign: 'center', height: 30, display: 'block', width: '100%'}}>
                      {item.icon && item.icon}
                    </div>
                    <div>
                      {item.quantity}
                      <br />
                      {i18n.t(`pluginspaces.${item.type}`) ?? '&nbsp;'}
                    </div>
                  </div>
                ))}
              </div>
              <div className='card-toolbar'>
                {loginInfo.profile && loginInfo.profile === 'admin' && (
                  <Button
                    text='Cadastrar Pluginspace'
                    color='primary'
                    iconColor='#FFF'
                    icon='fas fa-plus'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => navigate('/pluginspace/criar')}
                    btnClass='mb-5 fw-bolder'
                  />
                )}
              </div>
            </div>
            <div className='card-body'>
              <div className='d-flex align-items-center justify-content-start'>
                <div className='d-flex w-50 '>
                  <div className=' align-items-end  justify-content-start me-5 flex-grow-1'>
                    <span className='align-self-start'>Status</span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      options={statusOptions}
                      value={filterStatus}
                      placeholder={'Status do PluginSpace'}
                      search={true}
                      change={(value: any) => {
                        setFilterStatus(value)
                      }}
                    />
                  </div>
                  <div className=' align-items-end  justify-content-start me-5 flex-grow-1'>
                    <span className='align-self-start'>Tipo</span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      options={optionsFilter}
                      value={filterPluginspace}
                      placeholder={'Status do Produto'}
                      search={true}
                      change={(value: any) => setFilterPluginspace(value)}
                    />
                  </div>
                </div>

                <div
                  className='d-flex align-items-end w-50 justify-content-end h-100'
                  style={{
                    marginTop: '48px',
                  }}
                >
                  <Button
                    text='Filtrar'
                    color='primary'
                    iconColor='#FFF'
                    icon='fas fa-filter'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={async () => {
                      setLoading(true)
                      await filterProdutos()
                      setLoading(false)
                    }}
                    btnClass='mb-0 fw-bolder'
                  />
                </div>
              </div>
              {loadingTable ? (
                <Loading />
              ) : (
                <>
                  <Datatable
                    data={data}
                    headers={[
                      {key: 'Tipo', value: 'type', type: 'bullet'},
                      {key: 'Id', value: 'id', type: 'default'},
                      {key: 'Nome', value: 'name', type: 'default'},
                      {key: 'Subdomínio', value: 'subdomain', type: 'default'},
                      {
                        key: 'Status',
                        value: 'status',
                        type: 'badge',
                        badge: {
                          ativo: 'success',
                          inativo: 'danger',
                        },
                      },
                      {key: 'Criado em', value: 'created', type: 'default'},
                      {key: 'CNPJ', value: 'cnpj', type: 'cnpj'},
                      {key: 'Ações', value: 'acoes', type: ''},
                    ]}
                    options={[
                      {
                        icon: 'la la-gear',
                        action: () => {},
                        title: 'Configurações',
                        dropdownItems: [
                          {
                            text: 'COPIAR CONFIGURAÇÕES',
                            action: (item) =>
                              navigate(`/pluginspace/copy-configurations/${item.id}`),
                          },
                          // {text: 'COPIAR IMAGENS', action: () => {}}
                        ],
                      },
                      {
                        icon: 'fas fa-pen',
                        action: (item) => {
                          navigate(`/pluginspace/editar/${item.id}`)
                        },
                        title: 'Editar',
                      },
                      {
                        icon: '',
                        isButton: true,
                        textButton: 'Acessar',
                        action: (item) => {
                          accessPluginspace(item.id)
                        },
                        color: 'info',
                      },
                      //{ icon: "fas fa-trash", action: () => {}, path: '', title: "Excluir modalidade" },
                    ]}
                    color='primary'
                  />
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const Pluginspace: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[{title: 'Contas', path: 'pluginspace', isActive: true}]}>
        Contas
      </PageTitle>
      <PluginspaceContent />
    </>
  )
}

export {Pluginspace}
